import * as dp from "@mui/x-date-pickers-pro";
import { ReactNode } from "react";
import moment from "moment";

export interface IDatePickerProps<TDate> extends dp.DatePickerProps<TDate> {
  name?: string;
  error?: boolean;
  helperText?: string;
  required?: boolean;
  children?: ReactNode
}
const DatePicker = (props: IDatePickerProps<any>): JSX.Element => {
  const { name, error, helperText, required, children, ..._props } = props;
  return (
    <dp.DatePicker
      {...props}
      value={_props.value ? moment(_props.value) : null}
      minDate={_props.minDate ? moment(_props.minDate) : null}
      maxDate={_props.maxDate ? moment(_props.maxDate) : null}
      onChange={(v, c) => {
        if (c.validationError)
          return;

        if (_props.onChange)
          _props.onChange({ target: { name: name, value: moment(v)?.format('yyyy-MM-DD') || null } }, c)
      }}
      slotProps={{
        textField: {
          required: required,
          name: name,
          variant: "outlined",
          fullWidth: true,
          InputLabelProps: { shrink: true },
          size: "small",
          error: props.error,
          helperText: props.helperText
        },
      }}
    />
  );
};

export default DatePicker;
